export default __webpack_public_path__ + "static/Mont-Black-3db32324cc8ff31136ec1bc11a9ea8c7.otf";